import "../../../Styles/Footer.css";
import { FaInstagram, FaFacebookF, FaViber, FiMail, FiMapPin } from "../../../icons";
import useCategoryNavigation from "../../../Hooks/useCategoryNavigation";
import { NAV_ITEMS } from "../CategoryNav/navItems";

const Footer = () => {
  const { goToMaterial } = useCategoryNavigation();

  return (
    <footer id="footer" className="site-footer">
      {/* Brand row */}
      <div className="footer-brand-row">
        <div className="footer-brand-head">
          <img
            src="/doro_logo.png"
            alt="Jewelry Shop Doro"
            className="footer-logo"
          />
          <span className="footer-wordmark">
            Jewelry Shop
            <strong>Doro</strong>
          </span>
        </div>
        <p className="footer-tagline">
          Ručno izrađen nakit od zlata i srebra — po vašoj i našoj želji.
        </p>
      </div>

      <div className="footer-divider" />

      <div className="footer-grid">
        {/* Categories */}
        <div className="footer-col">
          <h4 className="footer-heading">Kategorije</h4>
          <ul className="footer-links">
            {NAV_ITEMS.map((item) => (
              <li key={item.label}>
                <button
                  type="button"
                  className="footer-link"
                  onClick={() => goToMaterial(item.material)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h4 className="footer-heading">Kontakt</h4>
          <ul className="footer-links">
            <li>
              <a
                className="footer-contact"
                href="https://www.instagram.com/jewelry_shop_doro/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="footer-c-icon" />
                <span>@jewelry_shop_doro</span>
              </a>
            </li>
            <li>
              <a
                className="footer-contact"
                href="https://www.facebook.com/jewelryshopdoro/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF className="footer-c-icon" />
                <span>Facebook stranica</span>
              </a>
            </li>
            <li>
              <a
                className="footer-contact"
                href="viber://chat?number=+381605500750"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaViber className="footer-c-icon" />
                <span>+381 60 5500 750</span>
              </a>
            </li>
            <li>
              <a
                className="footer-contact"
                href="mailto:silvershopdoro@gmail.com?subject=Pitanje%20mušterije"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FiMail className="footer-c-icon" />
                <span>silvershopdoro@gmail.com</span>
              </a>
            </li>
          </ul>
        </div>

        {/* Location */}
        <div className="footer-col">
          <h4 className="footer-heading">Lokacija</h4>
          <p className="footer-address">
            <FiMapPin className="footer-c-icon" />
            <span>Nikole Pašića 7, Novi Sad</span>
          </p>
          <p className="footer-address footer-address-muted">
            <span>Radno vreme: pon — sub</span>
          </p>
        </div>

        {/* Map */}
        <div className="footer-col footer-map-col">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2808.599879977676!2d19.846446976543263!3d45.2558832473135!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475b119028100867%3A0xc53f068339cb9f89!2sJewelry%20Shop%20Doro!5e0!3m2!1ssr!2srs!4v1758716121016!5m2!1ssr!2srs"
            style={{ border: "0" }}
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="footer-map"
            title="Doro map"
          ></iframe>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
